import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var Activity = require("components/writing/activities/Activity");

const WritingActions = require('lib/actions/WritingActions');
const WritingSelectors = require('lib/selectors/WritingSelectors');

require("writing/activities/activity_page.scss");

@connect(
	(state, props) => ({
		activity: WritingSelectors.getActivity({state, id: props.match.params.id})
	}),
	(dispatch, props) => ({
		populateData: () => dispatch(WritingActions.fetchActivity({id: props.match.params.id, embeds: ["activity.format"]}))
	}),
)
@providePopulateData()
class ActivityPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
		};
	}

	render() {
		if (this.props.activity == null) {
			return <div className="container" id="activityPage"></div>
		}

		return (
			<div className="container" id="activityPage">
				<Activity activity={ this.props.activity } />
			</div>
		)
	}

};

ActivityPage.propTypes = PageStrictPropTypes({
});

module.exports = ActivityPage;


// WEBPACK FOOTER //
// ./modules/components/writing/activities/ActivityPage.js